module.exports = __webpack_public_path__ + "img/ug.9530622e.svg";